import React from 'react';
import Select from '@atlaskit/select';
import { AsyncSelect } from '@atlaskit/select';
import interpolate from '../utils/interpolate';
import { SearchIssues } from '../dataStore/atlassian-services';

export class SearchSelect extends React.Component {
  constructor(props) {
    super(props);
    const valueExpression = props.fieldConfiguration.valueExpression;
    const idField = props.fieldConfiguration.idField;
    const dataSource = props.dataSource;
    const fieldConfiguration = props.fieldConfiguration;
    const issueFieldsArray = props.issueFieldsArray;

    if (props.fieldConfiguration.fieldType === 'select') {
      fetch(props.dataSource.url)
        .then((response) => response.json())
        .then((options) => {
          let result = options.map(function (item) {
            const labelData = interpolate(valueExpression, { item: item });

            return {
              label: labelData,
              value: item[idField],
              data: item,
            };
          });

          if (fieldConfiguration.sorting === '1') {
            result = result.sort();
          } else if (fieldConfiguration.sorting === '2') {
            result = result.sort().reverse();
          }

          this.setState({
            existingValues: [],
            dataSource: dataSource,
            fieldConfig: fieldConfiguration,
            selectOptions: result,
            issueFieldsArray: issueFieldsArray,
          });
        });
    } else {
      this.state = {
        existingValues: [],
        dataSource: props.dataSource,
        fieldConfig: props.fieldConfiguration,
        issueFieldsArray: issueFieldsArray,
      };
    }
  }

  promiseOptions = (inputValue) =>
    inputValue.length >= 3
      ? fetch(
          `${
            this.state.dataSource.url.indexOf('{param}') > 0
              ? this.state.dataSource.url.replace('{param}', inputValue)
              : this.state.dataSource.url.endsWith('/')
              ? this.state.dataSource.url + inputValue
              : this.state.dataSource.url + '/' + inputValue
          }`,
          {
            method: 'GET',
            headers: {
              Authorization:
                this.state.dataSource.auth === 'basic'
                  ? 'Basic ' +
                    window.btoa(
                      this.state.dataSource.username + ':' + this.state.dataSource.password
                    )
                  : this.state.dataSource.auth === 'token'
                  ? this.state.dataSource.token
                  : '', //"TGlkSmlyYTp2MGV2N2RzZTRmOGM1eXN6",
            },
          }
        ).then((response) => {
          return this.handleResponse(response, this);
        })
      : // .then(this.handleResponse, this)
        [];

  promiseOptionsJira = (inputValue) =>
    inputValue.length >= 3
      ? window.AP.request({
          type: 'POST',
          url: `/rest/api/3/search/jql`,
          contentType: 'application/json',
          data: JSON.parse(
            JSON.stringify(`{
                        "expand": "names",
                        "jql": "${this.getJql(
                          this.state.dataSource.jql,
                          this.state.dataSource.selectField,
                          inputValue
                        )}",
                        "maxResults": 15,
                        "fieldsByKeys": false,
                        "fields": []
                      }`)
          ),
        }).then((response) => {
          return this.handleIssuesResponse(response.body, this);
        })
      : [];

  getJql = (jql, field, val) => {
    let result = `'${this.getFieldName(field, this.state.issueFieldsArray)}' ~ '${val.trim()}*'`;
    if (jql) {
      jql = jql.replace(/"/g, "'");
      result = `${result} AND ${jql}`;
      if (jql.toLowerCase().indexOf('order by') < 0) {
        result = `${result} ORDER BY created DESC`;
      }
    }
    if (result.toLowerCase().indexOf('and order by') >= 0) {
      result = result.toLowerCase().replace('and order by', 'order by');
    }

    return result;
  };

  getFieldName = (field, fieldArray) => {
    if (!fieldArray) return field;

    let fld = fieldArray.filter((n) => n.id === field)[0];
    let fldId = fld ? fld.name : field;

    return fldId;
  };

  promiseFetch = (inputValue) =>
    inputValue.length >= 3
      ? SearchIssues(
          this.props.token,
          JSON.parse(`{
                        "expand": "names",
                        "jql": "${this.getJql(
                          this.state.dataSource.jql,
                          this.state.dataSource.selectField,
                          inputValue
                        )}",
                        "maxResults": 15,
                        "fieldsByKeys": false,
                        "fields": [],
                        "startAt": 0
                      }`)
        ).then((response) => {
          return this.handleIssuesResponse(response, this);
        })
      : [];

  promiseOptionsJiraCustomers = (inputValue) =>
    inputValue.length >= 3
      ? window.AP.request(
          `/rest/servicedeskapi/request?searchTerm=${inputValue.trim()}${
            this.state.fieldConfig.issuesStatus
              ? '&requestStatus=' + this.state.fieldConfig.issuesStatus
              : ''
          }`
        ).then((response) => {
          return this.handleRequestsResponse(response.body, this);
        })
      : [];

  handleResponse(response, component) {
    return response.text().then((text) => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      const idField = component.state.fieldConfig.idField;
      const valueExpression = component.state.fieldConfig.valueExpression;

      let result = data.map(function (item) {
        const labelData = interpolate(valueExpression, { item: item });

        return {
          label: labelData,
          value: item[idField],
          data: item,
        };
      });

      if (component.state.fieldConfig.sorting === '1') {
        result = result.sort();
      } else if (component.state.fieldConfig.sorting === '2') {
        result = result.sort().reverse();
      }

      component.setState({ existingValues: result });
      return result;
    });
  }

  handleIssuesResponse(response, component) {
    const fieldKey = this.state.dataSource.selectField;

    const result = response.issues.map(function (item) {
      return {
        label: `${item.key} - ${item.fields[fieldKey]}`,
        value: item.key,
        data: item.fields[fieldKey],
      };
    });
    component.setState({ existingValues: result });
    return result;
  }

  handleRequestsResponse(response, component) {
    const jData = JSON.parse(response);
    const fieldKey = this.state.dataSource.selectField;

    const result = jData.values.map(function (item) {
      return {
        label: `${item.issueKey} - ${
          item.requestFieldValues.filter((d) => d.fieldId === fieldKey)[0]?.value
        }`,
        value: item.issueKey,
        data: item.requestFieldValues.filter((d) => d.fieldId === fieldKey)[0]?.value,
      };
    });

    component.setState({ existingValues: result });
    return result;
  }

  onSelectionChange = (e) => {
    this.props.onSelectionChange(e);
  };

  render() {
    return this.state ? (
      this.state.fieldConfig.fieldType === 'select' ? (
        <Select
          isClearable
          inputId='single-select-example'
          className='single-select'
          classNamePrefix='react-select'
          onChange={this.onSelectionChange}
          options={this.state.selectOptions}
          maxMenuHeight={180}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          placeholder='Choose a option'
        />
      ) : (
        <AsyncSelect
          id='slSearchSelect'
          name='slSearchSelect'
          isClearable
          placeholder='search issues'
          maxMenuHeight={200}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={this.onSelectionChange}
          defaultOptions={this.state.existingValues}
          loadOptions={
            this.state.dataSource.sourceType === 'jira' ? this.promiseFetch : this.promiseOptions
          }
        />
      )
    ) : null;
  }
}
